import React from 'react';
import DropdownList from './DropdownList';
import styled from 'styled-components';
import Media from 'css/Media';
import WP from 'WP';


class SkiPackageInputFields extends React.Component {
    state = {
        hasOptions: false,
        currentProduct: null,
    };

    handleChange = product => {
        this.setState({
            hasOptions: product.acf.package_type === 'skis',
            currentProduct: product,
        }, () => {
            this.props.handleReservationsChange({ product: product, extraFields: {} }, this.props.idx);
        });
    };

    handleSizeChange = (value, name) => {
        const { currentProduct } = this.state;

        this.props.handleReservationsChange({
            product: currentProduct,
            extraFields: {[name]: value}
        }, this.props.idx);
    };

    render() {
        const {
            products,
            shoeSize,
            skiLength,
            defaultValue
        } = this.props;

        const {
            hasOptions
        } = this.state;

        return (
            <React.Fragment>
                <DefaultFieldDropdownList
                    name="product"
                    defaultValue={defaultValue ? defaultValue : null}
                    onChange={this.handleChange}
                    options={products}
                    label={WP.trans.selectPackage}
                />

                {hasOptions && (
                    <Options>
                        <SkiLengthDropdownList
                            name="skiLength"
                            onChange={value => this.handleSizeChange(value, 'skiLength')}
                            options={skiLength}
                            label={WP.trans.chooseSkiLength}
                        />
                        <ShoeSizeDropdownList
                            name="shoeSize"
                            onChange={value => this.handleSizeChange(value, 'shoeSize')}
                            options={shoeSize}
                            label={WP.trans.chooseShoeSize}
                        />
                    </Options>
                )}
            </React.Fragment>
        );
    }
};

export default SkiPackageInputFields;

const DefaultFieldDropdownList = styled(DropdownList)`
    width: 100%;
    padding-bottom: ${props => props.theme.spacing.contentXL};

    ${Media.greaterThan('m')`
        width: 47%;
        padding-bottom: ${props => props.theme.spacing.elementXS};
    `}
`;
const Options = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;

    ${Media.greaterThan('m')`
        flex-direction: row;
    `}
`;

const SkiLengthDropdownList = styled(DropdownList)`
    width: 100%;
    padding-bottom: ${props => props.theme.spacing.contentXL};

    ${Media.greaterThan('m')`
        width: 47%;
        padding-bottom: ${props => props.theme.spacing.elementXS};
        margin-right: 5.6%;
    `}
`;

const ShoeSizeDropdownList = styled(DropdownList)`
    width: 100%;
    padding-bottom: ${props => props.theme.spacing.contentXL};

    ${Media.greaterThan('m')`
        width: 47%;
        padding-bottom: ${props => props.theme.spacing.elementXS};
    `}
`;